export const siteModule = {
  namespaced: true,
  state: () => ({
    data: null,
  }),
  mutations: {
    setSiteData(state, site) {
      state.data = site
    }
  }
}
